export const REFUND_REASONS_OPTIONS = [
  { label: "Item defective", value: 0 },
  {
    label: "Product and box are both damaged",
    value: 1,
  },
  {
    label: "Box is damaged, but product is not",
    value: 2,
  },
  {
    label: "Missing or broken parts",
    value: 3,
  },
  {
    label: "Inaccurate description",
    value: 4,
  },
  {
    label: "Product damaged, but box OK",
    value: 5,
  },
  {
    label: "Wrong item was received",
    value: 6,
  },
];

export const getRefundReasonLabel = (value: number): string => {
  if (value === undefined || value === null) return "";
  const option = REFUND_REASONS_OPTIONS.find((opt) => opt.value === value);
  return option?.label || "";
};
